module.exports = __webpack_public_path__ + "img/tu02.62d80336.jpg";